import { Col, Row, Spin } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import AntdSelect from 'components/Form/Select'
import React, { useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import {
  ComeAcross,
  ExperiencetagsData,
  LoveAboutagsData,
} from '../../../Resume/DrawerComponents/AdditionalDetails/Constant'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Content,
  CustomCheckableTags,
  CustomRate,
  Description,
  FeedbackSubHeading,
  FeedbackWrapper,
  QuestionnaireSectionWrapper,
  Spacer,
  TagWrapper,
  TopHeading,
} from '../../Style/style'

const Feedback = ({
  updateStudentFeedback,
  ApplyRole,
  RejectedRole,
  geStudentQuestionaireResult,
}) => {
  const navigate = useNavigate()
  const [feedBackDrawer, setFeedBackDrawer] = useState(false)
  const [others, setOthers] = useState('')
  const loading = false
  const jobAppliedFailed = false
  const appliedDrawer = false
  const failDrawer = false
  const [disable, setDisable] = useState(true)
  const [feedbackPayload, setFeedbackPayload] = useState({
    comeAcross: '',
    rating: 0,
    aboutUs: [],
    experience: [],
    comments: '',
  })

  //to block back button
  history.pushState(null, null, location.href)
  window.onpopstate = function () {
    history.go(1)
  }

  const onChange = (value, key) => {
    if (key == 'comeAcross' && value === 'Others') {
      setOthers('Others')
    } else {
      setFeedbackPayload({ ...feedbackPayload, [key]: value })
      setOthers()
    }
  }

  const onOthersChange = (value, key) => {
    setFeedbackPayload({ ...feedbackPayload, [key]: value })
  }

  const areAllValuesNotEmpty = () => {
  
    const value = feedbackPayload.rating;

  return (
    value === 0 ||
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0)
  );
  }

  const handleChange = (tag, checked, key) => {
    const nextSelectedTags = checked
      ? [...feedbackPayload[key], tag]
      : feedbackPayload[key].filter(t => t !== tag)
    setFeedbackPayload({
      ...feedbackPayload,
      [key]: nextSelectedTags,
    })
  }

  useEffect(() => {
    const disable = areAllValuesNotEmpty()
    setDisable(disable)
  }, [feedbackPayload])

  const updateFeedback = async () => {
    if (!jobAppliedFailed) {
      const feedbackResponse = await updateStudentFeedback(feedbackPayload)
      if (!feedbackResponse?.status == 201) {
        ErrorMessage(feedbackResponse.message)
      }
    }
    navigate(`/applied_roles`)

    // await studentQuestionnariResult()
  }

  return (
    <Container alignCenter column center>
      {!loading ? (
        <>
          {!feedBackDrawer && !appliedDrawer && !failDrawer && (
            <Content spaceBetween center column>
              <Flex column>
                <TopHeading>
                  Where did you come across information about this job role?
                </TopHeading>
                <Spacer />
                <AntdSelect
                  rules={[
                    {
                      required: true,
                      message: 'Please select any option',
                    },
                  ]}
                  OptionData={ComeAcross || []}
                  name={'comeAcross'}
                  onChange={value => onChange(value, 'comeAcross')}
                  valueParam="value"
                  nameParam="value"
                  value={others ?? feedbackPayload.comeAcross}
                  placeholder="Eg. PluginLive *"
                />
                <Spacer />
                {others && (
                  <AntdInput
                    placeholder="Come Across"
                    onChange={e => onOthersChange(e.target.value, 'comeAcross')}
                  />
                )}
              </Flex>
              <Control width="100%" center top="35px">
                <Button.Secondary
                  text="Next"
                  disabled={!feedbackPayload.comeAcross}
                  onClick={() => setFeedBackDrawer(!feedBackDrawer)}
                />
              </Control>
            </Content>
          )}
          {feedBackDrawer && !appliedDrawer && !failDrawer && (
            <QuestionnaireSectionWrapper column width={'610px'}>
              <Spacer />
              <FeedbackWrapper>
                <Flex column>
                  <TopHeading center>
                    Tell Us About Your Over All Experience With PluginLive
                  </TopHeading>
                  <Description center>
                    Please share your feedback by assigning a star rating. Your
                    input is valuable to us.
                  </Description>
                  <Flex center>
                    <CustomRate
                      defaultValue={0}
                      allowHalf
                      value={feedbackPayload.rating}
                      onChange={value => onChange(value, 'rating')}
                    />
                  </Flex>
                  <FeedbackSubHeading center>
                    What Do You Love About Us ?
                  </FeedbackSubHeading>
                  <Row justify="center" align="middle" gutter={[10, 5]}>
                    {LoveAboutagsData?.map((tag,index) => (
                      <Col key={index+"data"}>
                        <CustomCheckableTags
                          key={tag}
                          checked={feedbackPayload?.aboutUs?.includes(tag)}
                          onChange={checked =>
                            handleChange(tag, checked, 'aboutUs')
                          }
                        >
                          <TagWrapper> {tag}</TagWrapper>
                        </CustomCheckableTags>
                      </Col>
                    ))}
                  </Row>
                  <FeedbackSubHeading style={{ marginTop: '35px' }} center>
                    How can we make your Experience Better ?
                  </FeedbackSubHeading>
                  <Row justify="center" align="middle" gutter={[10, 5]}>
                    {ExperiencetagsData?.map((tag,index) => (
                      <Col  key={index+"expData"}>
                        <CustomCheckableTags
                          key={tag}
                          checked={feedbackPayload?.experience?.includes(tag)}
                          onChange={checked =>
                            handleChange(tag, checked, 'experience')
                          }
                        >
                          <TagWrapper> {tag}</TagWrapper>
                        </CustomCheckableTags>
                      </Col>
                    ))}
                  </Row>
                  <Spacer />
                  <TextArea
                    rows={4}
                    value={feedbackPayload.comments}
                    placeholder="Want to share anything else ? Type here.."
                    onChange={e => onChange(e.target.value, 'comments')}
                  />
                </Flex>
                <Control width="100%" center top="35px">
                  <Button.Primary
                    text="Send Your Feedback"
                    disable={disable}
                    onClick={() => updateFeedback()}
                  />
                </Control>
              </FeedbackWrapper>
            </QuestionnaireSectionWrapper>
          )}
        </>
      ) : (
        <Spin />
      )}
    </Container>
  )
}

export default Feedback
